import React from 'react';

const FormattedAbout = ({ text }) => {
  // Return early if text is undefined or null
  if (!text) {
    return null;
  }

  const formatText = (content) => {
    // Split content into sections
    const sections = content.split('\n\n');
    
    return sections.map((section, index) => {
      // Check if this section contains a list (by looking for single line breaks)
      if (section.includes('\n') && section.split('\n')[0].endsWith(':')) {
        const [title, ...items] = section.split('\n');
        return (
          <div key={index} className="mb-4">
            <p className="mb-2 text-slate-600 font-inter font-light text-[14px]">{title}</p>
            <ul className="list-disc pl-6 text-slate-600 font-inter font-light text-[14px]">
              {items.map((item, itemIndex) => (
                <li key={itemIndex} className="mb-1">
                  {item.trim()}
                </li>
              ))}
            </ul>
          </div>
        );
      }
      // Regular paragraph
      return (
        <p key={index} className="mb-4 text-slate-600 font-inter font-light text-[14px]">
          {section.trim()}
        </p>
      );
    });
  };

  return (
    <div className="my-6 text-black h-full w-full px-2">
      {formatText(text)}
    </div>
  );
};

export default FormattedAbout;